var map = {
	"./about-us/about-us.vue": "B3LO",
	"./advice-and-support/advice-and-support.vue": "sKaE",
	"./contact/contact.vue": "0dJg",
	"./home/home.vue": "/rOH",
	"./services/services.vue": "CN0p"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "7KS0";


//////////////////
// WEBPACK FOOTER
// ./src/pages/page ^\.\/.*\.vue$
// module id = 7KS0
// module chunks = 0